$.loading = {
    show: function () {
        $('.loading').show();
    },
    hide: function () {
        $('.loading').hide();
    }
};

$(document).ready(function() {

    var $tokenMeta = $('meta[name="csrf-token"]');

    if ($tokenMeta.length > 0) {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $tokenMeta.attr('content')
            }
        });
    }

});
